import { AdminMe } from '@core/domains/adminMe/admin-me';
import { AdminMeStoreService } from '@core/domains/adminMe/adminMe-store.service';
import { Injectable } from '@angular/core';

import { ClientConfigService } from '@core/domains/config/client-config.service';
import { ThemesService } from '@core/domains/destination/theme/themes.service';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, filter, mergeMap } from 'rxjs/operators';
import { PaginatedResponse } from '@core/resources/resource.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ClientConfig } from '@core/domains/config/client-config';
import { Theme } from '@core/domains/destination/theme/theme';
import { ErrorManagementService } from '@core/tools/error.codes';
import { SAAS_DNS_FILTER, SAAS_URL_FILTER } from '@core/constants/products.constant';
import { of } from 'rxjs';

@Injectable()
export class PrefetchResolverService  {

  constructor(
    private admin: AdminMeStoreService,
    private config: ClientConfigService,
    private themes: ThemesService,
    private errors: ErrorManagementService,
  ) { }

  fetchThemesList(): Observable<PaginatedResponse<Theme>> {
    return this.themes.list().pipe(catchError((err: HttpErrorResponse) => this.errors.errorManagement<never>(err)));
  }

  fetchClientConfig(): Observable<ClientConfig> {
    return this.config.read().pipe(catchError((err: HttpErrorResponse) => this.errors.errorManagement<never>(err)));
  }

  resolve(): Observable<ClientConfig | AdminMe> {
    const me = this.admin.adminMe || this.admin.initAdmin();
    return of(me).pipe(
      filter((adminMe: AdminMe) => adminMe.products.includes(SAAS_URL_FILTER) || adminMe.products.includes(SAAS_DNS_FILTER)),
      mergeMap(() => this.fetchThemesList()),
      mergeMap(() => this.fetchClientConfig()),
    );
  }
}
